import * as React from 'react';
import Styled, { css } from 'styled-components';

import { VALID_SVG_COLOR } from '../../lib/StyledComponents/Theme/common';
import { normalizeColor } from '../_ThemeTwo_/Utils/Styles/normalizeColor';
import { ISVGProps } from '../../images/icons/common';

export type VALID_ICONS =
  | 'tooltip'
  | 'secure'
  | 'lock'
  | 'dollar'
  | 'document'
  | 'money'
  | 'check-circle'
  | 'exclamation-circle'
  | 'date'
  | 'amount'
  | 'issuer'
  | 'next'
  | 'product'
  | 'chart'
  | 'certificate'
  | 'loan-amount'
  | 'admin-fee'
  | 'amount-received'
  | 'ach'
  | 'rcc'
  | 'alert-close'
  | 'avatar'
  | 'phone'
  | 'call'
  | 'cancel'
  | 'email'
  | 'email-outline'
  | 'arrow-top'
  | 'arrow-right'
  | 'arrow-bottom'
  | 'arrow-left'
  | 'arrow-forward'
  | 'arrow-back'
  | 'arrow-upward'
  | 'arrow-double-upward'
  | 'arrow-downward'
  | 'minus'
  | 'plus'
  | 'equals'
  | 'done'
  | 'hide'
  | 'profile'
  | 'bank-history'
  | 'bank'
  | 'upload'
  | 'signature'
  | 'block-arrow-right'
  | 'block-arrow-down'
  | 'block-arrow-up'
  | 'process-bank'
  | 'bell-alert'
  | 'close'
  | 'close-small'
  | 'close-large'
  | 'workflow-close'
  | 'success'
  | 'identity'
  | 'face-recognition'
  | 'confirm-number'
  | 'circle-upload'
  | 'circle-alert'
  | 'circle-alert-large'
  | 'circle-info'
  | 'info'
  | 'avatar-thumb'
  | 'upload-camera'
  | 'snapshot'
  | 'phone-verification'
  | 'fraud-liability'
  | 'fast-process'
  | 'limit-increase'
  | 'date-arrow-right'
  | 'date-arrow-left'
  | 'scheduled'
  | 'arrow-down'
  | 'arrow-up'
  | 'calender'
  | 'circle-add'
  | 'circle-denied'
  | 'circle-check'
  | 'circle-delete'
  | 'business'
  | 'nav-statements'
  | 'nav-dashboard'
  | 'nav-payments'
  | 'nav-settings'
  | 'return-arrow'
  | 'forward-arrow'
  | 'money-and-time'
  | 'new-loan'
  | 'new-card'
  | 'continue-card'
  | 'continue-loan'
  | 'review-card'
  | 'review-loan'
  | 'personal-loan'
  | 'mini-card'
  | 'view-new-window'
  | 'download'
  | 'download-circle'
  | 'telephone'
  | 'calendar-date'
  | 'send-message'
  | 'cheque'
  | 'sync'
  | 'smartphone'
  | 'progress-done'
  | 'home'
  | 'check-list'
  | 'equal-housing-lender'
  | 'loading-hourglass'
  | 'question'
  | 'status-circle'
  | 'status-outline'
  | 'select-input-arrow'
  | 'checkbox-done'
  | 'lock-large'
  | 'product-pos'
  | 'needs-approval-status'
  | 'acceptable-status'
  | 'unacceptable-status'
  | 'file-multiple'
  | 'open-in-new'
  | 'leaf'
  | 'timeline'
  | 'add-note'
  | 'installment-paid'
  | 'device-info'
  | 'list'
  | 'reminder'
  | 'check'
  | 'auto-pay'
  | 'format-rotate'
  | 'shopping-bag'
  | 'star'
  | 'rewards'
  | 'login'

  // partner portal
  | 'psaes'
  | 'complaints'
  | 'disputes'
  | 'reports'
  | 'documents'
  | 'payment-gateway'
  | 'payment-tree'
  | 'new-folder'
  | 'delete'
  | 'drag'
  | 'edit'
  | 'filter'
  | 'helpdesk'
  | 'bug-report'
  | 'change-request'
  | 'inquiry'
  | 'service-incident'
  | 'service-incident-outline'
  | 'crm'
  | 'settings'
  | 'ellipses'
  | 'folder'
  | 'folder-outline'
  | 'file'
  | 'new-application'
  | 'looker'
  | 'access'
  | 'onboarding'
  | 'policy'
  | 'reliability'
  | 'ticket'
  | 'menu'
  | 'search'
  | 'add-participant'
  | 'dont-notify'
  | 'add-attachment'
  | 'send-link'
  | 'failed'
  | 'in-progress'
  | 'not-triggered'
  | 'passed'
  | 'workflow'
  | 'knowledge-base'
  | 'shape'
  | 'master-card'
  | 'logout'
  | 'reminder-outline'
  | 'paper-clip'
  | 'map-pin'
  | 'website'
  | 'archive'
  | 'swap'
  | 'expand'
  | 'link'
  | 'download-alt'
  | 'product-auto'
  | 'product-loan'
  | 'product-card'
  | 'product-admin'

  // images
  | 'autopay'
  | 'autopay-change'
  | 'card-locked'
  | 'card-success'
  | 'process-bank'
  | 'process-decision'
  | 'process-snapshot';

export const SVG_INFO_MAP = new Map<VALID_ICONS, React.FC<ISVGProps>>([
  ['tooltip', React.lazy(() => import(`../../images/icons/IconTooltip`))],
  ['check-circle', React.lazy(() => import(`../../images/icons/IconCheckCircle`))],
  ['exclamation-circle', React.lazy(() => import(`../../images/icons/IconExclamationCircle`))],
  ['lock', React.lazy(() => import(`../../images/icons/IconLock`))],
  ['document', React.lazy(() => import(`../../images/icons/IconDocument`))],
  ['money', React.lazy(() => import(`../../images/icons/IconMoney`))],
  ['date', React.lazy(() => import(`../../images/icons/IconDate`))],
  ['amount', React.lazy(() => import(`../../images/icons/IconAmount`))],
  ['issuer', React.lazy(() => import(`../../images/icons/IconIssuer`))],
  ['next', React.lazy(() => import(`../../images/icons/IconNext`))],
  ['view-new-window', React.lazy(() => import(`../../images/icons/IconViewNewWindow`))],
  ['download', React.lazy(() => import(`../../images/icons/IconDownload`))],
  ['download-circle', React.lazy(() => import(`../../images/icons/IconDownloadCircle`))],
  ['product', React.lazy(() => import(`../../images/icons/IconProduct`))],
  ['avatar', React.lazy(() => import(`../../images/icons/IconAvatar`))],
  ['phone', React.lazy(() => import(`../../images/icons/IconPhone`))],
  ['call', React.lazy(() => import(`../../images/icons/IconCall`))],
  ['cancel', React.lazy(() => import(`../../images/icons/IconCancel`))],
  ['email-outline', React.lazy(() => import(`../../images/icons/IconEmailOutline`))],
  ['arrow-top', React.lazy(() => import(`../../images/icons/IconArrowTop`))],
  ['arrow-right', React.lazy(() => import(`../../images/icons/IconArrowRight`))],
  ['arrow-bottom', React.lazy(() => import(`../../images/icons/IconArrowBottom`))],
  ['arrow-left', React.lazy(() => import(`../../images/icons/IconArrowLeft`))],
  ['arrow-forward', React.lazy(() => import(`../../images/icons/IconArrowForward`))],
  ['arrow-back', React.lazy(() => import(`../../images/icons/IconArrowBack`))],
  ['arrow-upward', React.lazy(() => import(`../../images/icons/IconArrowUpward`))],
  ['arrow-double-upward', React.lazy(() => import(`../../images/icons/IconArrowDoubleUpward`))],
  ['arrow-downward', React.lazy(() => import(`../../images/icons/IconArrowDownward`))],
  ['minus', React.lazy(() => import(`../../images/icons/IconMinus`))],
  ['plus', React.lazy(() => import(`../../images/icons/IconPlus`))],
  ['equals', React.lazy(() => import(`../../images/icons/IconEquals`))],
  ['done', React.lazy(() => import(`../../images/icons/IconDone`))],
  ['hide', React.lazy(() => import(`../../images/icons/IconHide`))],
  ['success', React.lazy(() => import(`../../images/icons/IconSuccess`))],
  ['circle-upload', React.lazy(() => import(`../../images/icons/IconCircleUpload`))],
  ['circle-alert', React.lazy(() => import(`../../images/icons/IconCircleAlert`))],
  ['circle-alert-large', React.lazy(() => import(`../../images/icons/IconCircleAlertLarge`))],
  ['circle-info', React.lazy(() => import(`../../images/icons/IconCircleInfo`))],
  ['info', React.lazy(() => import(`../../images/icons/IconInfo`))],
  ['workflow-close', React.lazy(() => import(`../../images/icons/IconWorkflowClose`))],
  ['circle-add', React.lazy(() => import(`../../images/icons/IconCircleAdd`))],
  ['circle-denied', React.lazy(() => import(`../../images/icons/IconCircleDenied`))],
  ['circle-check', React.lazy(() => import(`../../images/icons/IconCircleCheck`))],
  ['circle-delete', React.lazy(() => import(`../../images/icons/IconCircleDelete`))],
  ['alert-close', React.lazy(() => import(`../../images/icons/IconAlertClose`))],
  ['close', React.lazy(() => import(`../../images/icons/IconClose`))],
  ['close-small', React.lazy(() => import(`../../images/icons/IconCloseSmall`))],
  ['close-large', React.lazy(() => import(`../../images/icons/IconCloseLarge`))],
  ['block-arrow-right', React.lazy(() => import(`../../images/icons/IconBlockArrowRight`))],
  ['date-arrow-right', React.lazy(() => import(`../../images/icons/IconDateArrowRight`))],
  ['date-arrow-left', React.lazy(() => import(`../../images/icons/IconDateArrowLeft`))],
  ['arrow-down', React.lazy(() => import(`../../images/icons/IconArrowDown`))],
  ['arrow-up', React.lazy(() => import(`../../images/icons/IconArrowUp`))],
  ['forward-arrow', React.lazy(() => import(`../../images/icons/IconForwardArrow`))],
  ['return-arrow', React.lazy(() => import(`../../images/icons/IconReturnArrow`))],
  ['scheduled', React.lazy(() => import(`../../images/icons/IconScheduled`))],
  ['calender', React.lazy(() => import(`../../images/icons/IconCalendar`))],
  ['chart', React.lazy(() => import(`../../images/icons/IconChart`))],
  ['certificate', React.lazy(() => import(`../../images/icons/IconCertificate`))],
  ['loan-amount', React.lazy(() => import(`../../images/icons/IconLoanAmount`))],
  ['admin-fee', React.lazy(() => import(`../../images/icons/IconAdminFee`))],
  ['amount-received', React.lazy(() => import(`../../images/icons/IconAmountReceived`))],
  ['ach', React.lazy(() => import(`../../images/icons/IconAch`))],
  ['rcc', React.lazy(() => import(`../../images/icons/IconRcc`))],
  ['avatar-thumb', React.lazy(() => import(`../../images/icons/IconAvatarThumb`))],
  ['bank-history', React.lazy(() => import(`../../images/icons/IconBankHistory`))],
  ['upload', React.lazy(() => import(`../../images/icons/IconUpload`))],
  ['signature', React.lazy(() => import(`../../images/icons/IconSignature`))],
  ['bell-alert', React.lazy(() => import(`../../images/icons/IconBellAlert`))],
  ['bank', React.lazy(() => import(`../../images/icons/IconBank`))],
  ['email', React.lazy(() => import(`../../images/icons/IconEmail`))],
  ['profile', React.lazy(() => import(`../../images/icons/IconProfile`))],
  ['calendar-date', React.lazy(() => import(`../../images/icons/IconCalendarDate`))],
  ['identity', React.lazy(() => import(`../../images/icons/IconIdentity`))],
  ['face-recognition', React.lazy(() => import(`../../images/icons/IconFaceRecognition`))],
  ['confirm-number', React.lazy(() => import(`../../images/icons/IconConfirmNumber`))],
  ['upload-camera', React.lazy(() => import(`../../images/icons/IconUploadCamera`))],
  ['phone-verification', React.lazy(() => import(`../../images/icons/IconPhoneVerification`))],
  ['snapshot', React.lazy(() => import(`../../images/icons/IconSnapshot`))],
  ['fraud-liability', React.lazy(() => import(`../../images/icons/IconFraudLiability`))],
  ['fast-process', React.lazy(() => import(`../../images/icons/IconFastProcess`))],
  ['limit-increase', React.lazy(() => import(`../../images/icons/IconLimitIncrease`))],
  ['business', React.lazy(() => import(`../../images/icons/IconBusiness`))],
  ['nav-statements', React.lazy(() => import(`../../images/icons/IconNavStatements`))],
  ['nav-dashboard', React.lazy(() => import(`../../images/icons/IconNavDashboard`))],
  ['nav-payments', React.lazy(() => import(`../../images/icons/IconNavPayments`))],
  ['nav-settings', React.lazy(() => import(`../../images/icons/IconNavSettings`))],
  ['new-loan', React.lazy(() => import(`../../images/icons/IconNewLoan`))],
  ['new-card', React.lazy(() => import(`../../images/icons/IconNewCard`))],
  ['continue-card', React.lazy(() => import(`../../images/icons/IconContinueCard`))],
  ['continue-loan', React.lazy(() => import(`../../images/icons/IconContinueLoan`))],
  ['review-card', React.lazy(() => import(`../../images/icons/IconReviewCard`))],
  ['review-loan', React.lazy(() => import(`../../images/icons/IconReviewLoan`))],
  ['personal-loan', React.lazy(() => import(`../../images/icons/IconPersonalLoan`))],
  ['mini-card', React.lazy(() => import(`../../images/icons/IconMiniCard`))],
  ['telephone', React.lazy(() => import(`../../images/icons/IconTelephone`))],
  ['send-message', React.lazy(() => import(`../../images/icons/IconSendMessage`))],
  ['cheque', React.lazy(() => import(`../../images/icons/IconCheque`))],
  ['secure', React.lazy(() => import(`../../images/icons/IconSecure`))],
  ['money-and-time', React.lazy(() => import(`../../images/icons/IconMoneyAndTime`))],
  ['sync', React.lazy(() => import(`../../images/icons/IconSync`))],
  ['smartphone', React.lazy(() => import(`../../images/icons/IconSmartphone`))],
  ['status-circle', React.lazy(() => import(`../../images/icons/IconStatusCircle`))],
  ['status-outline', React.lazy(() => import(`../../images/icons/IconStatusOutline`))],
  ['progress-done', React.lazy(() => import(`../../images/icons/IconProgressMarkDone`))],
  ['home', React.lazy(() => import(`../../images/icons/IconHome`))],
  ['check-list', React.lazy(() => import(`../../images/icons/CheckList`))],
  ['equal-housing-lender', React.lazy(() => import(`../../images/icons/IconEqualHousingLender`))],
  ['dollar', React.lazy(() => import(`../../images/icons/IconDollarSign`))],
  ['block-arrow-down', React.lazy(() => import(`../../images/icons/IconBlockArrowDown`))],
  ['block-arrow-up', React.lazy(() => import(`../../images/icons/IconBlockArrowUp`))],
  ['loading-hourglass', React.lazy(() => import(`../../images/icons/IconLoadingHourglass`))],
  ['question', React.lazy(() => import(`../../images/icons/IconQuestion`))],
  ['select-input-arrow', React.lazy(() => import(`../../images/icons/IconSelectInputArrow`))],
  ['checkbox-done', React.lazy(() => import(`../../images/icons/IconCheckboxDone`))],
  ['product-pos', React.lazy(() => import(`../../images/icons/IconProductPos`))],
  ['lock-large', React.lazy(() => import(`../../images/icons/IconLockLarge`))],
  ['needs-approval-status', React.lazy(() => import(`../../images/icons/IconNeedsApproval`))],
  ['acceptable-status', React.lazy(() => import(`../../images/icons/IconAcceptable`))],
  ['unacceptable-status', React.lazy(() => import(`../../images/icons/IconUnacceptable`))],
  ['file-multiple', React.lazy(() => import(`../../images/icons/IconFileMultiple`))],
  ['open-in-new', React.lazy(() => import(`../../images/icons/IconOpenInNew`))],
  ['leaf', React.lazy(() => import(`../../images/icons/IconLeaf`))],
  ['timeline', React.lazy(() => import(`../../images/icons/IconTimeLine`))],
  ['add-note', React.lazy(() => import(`../../images/icons/IconAddNote`))],
  ['installment-paid', React.lazy(() => import(`../../images/icons/IconInstallmentPaid`))],
  ['shape', React.lazy(() => import(`../../images/icons/IconShape`))],
  ['master-card', React.lazy(() => import(`../../images/icons/IconMasterCard`))],
  ['device-info', React.lazy(() => import(`../../images/icons/IconDeviceInfo`))],
  ['list', React.lazy(() => import(`../../images/icons/IconList`))],
  ['reminder', React.lazy(() => import('../../images/icons/IconReminder'))],
  ['paper-clip', React.lazy(() => import('../../images/icons/IconPaperClip'))],
  ['reminder-outline', React.lazy(() => import('../../images/icons/IconReminderOutline'))],
  ['check', React.lazy(() => import('../../images/icons/IconCheck'))],
  ['auto-pay', React.lazy(() => import('../../images/icons/IconAutoPay'))],
  ['map-pin', React.lazy(() => import('../../images/icons/IconMapPin'))],
  ['website', React.lazy(() => import('../../images/icons/IconWebsite'))],
  ['format-rotate', React.lazy(() => import('../../images/icons/IconFormatRotate'))],
  ['archive', React.lazy(() => import('../../images/icons/IconArchive'))],
  ['swap', React.lazy(() => import('../../images/icons/IconSwap'))],
  ['expand', React.lazy(() => import('../../images/icons/IconExpand'))],
  ['link', React.lazy(() => import('../../images/icons/IconLink'))],
  ['download-alt', React.lazy(() => import('../../images/icons/IconDownloadAlt'))],
  ['product-auto', React.lazy(() => import('../../images/icons/IconProductAuto'))],
  ['product-loan', React.lazy(() => import('../../images/icons/IconProductLoan'))],
  ['product-card', React.lazy(() => import('../../images/icons/IconProductCard'))],
  ['product-admin', React.lazy(() => import('../../images/icons/IconProductAdmin'))],
  ['shopping-bag', React.lazy(() => import('../../images/icons/IconShoppingBag'))],
  ['star', React.lazy(() => import('../../images/icons/IconStar'))],
  ['rewards', React.lazy(() => import('../../images/icons/IconRewards'))],
  ['login', React.lazy(() => import(`../../images/icons/IconLogin`))],

  // partners
  ['psaes', React.lazy(() => import(`../../images/icons/IconPSAEs`))],
  ['complaints', React.lazy(() => import(`../../images/icons/IconComplaints`))],
  ['disputes', React.lazy(() => import(`../../images/icons/IconDisputes`))],
  ['reports', React.lazy(() => import(`../../images/icons/IconReports`))],
  ['documents', React.lazy(() => import(`../../images/icons/IconDocuments`))],
  ['payment-gateway', React.lazy(() => import(`../../images/icons/IconPaymentGateway`))],
  ['payment-tree', React.lazy(() => import(`../../images/icons/IconPaymentTree`))],
  ['new-folder', React.lazy(() => import(`../../images/icons/IconNewFolder`))],
  ['delete', React.lazy(() => import(`../../images/icons/IconDelete`))],
  ['drag', React.lazy(() => import(`../../images/icons/IconDrag`))],
  ['edit', React.lazy(() => import(`../../images/icons/IconEdit`))],
  ['filter', React.lazy(() => import(`../../images/icons/IconFilter`))],
  ['helpdesk', React.lazy(() => import(`../../images/icons/IconHelpdesk`))],
  ['bug-report', React.lazy(() => import(`../../images/icons/IconBugReport`))],
  ['change-request', React.lazy(() => import(`../../images/icons/IconChange`))],
  ['inquiry', React.lazy(() => import(`../../images/icons/IconInquiry`))],
  ['service-incident', React.lazy(() => import(`../../images/icons/IconServiceIncident`))],
  ['service-incident-outline', React.lazy(() => import(`../../images/icons/IconServiceIncidentOutline`))],
  ['crm', React.lazy(() => import(`../../images/icons/IconCRM`))],
  ['settings', React.lazy(() => import(`../../images/icons/IconSettings`))],
  ['ellipses', React.lazy(() => import(`../../images/icons/IconEllipses`))],
  ['folder', React.lazy(() => import(`../../images/icons/IconFolder`))],
  ['folder-outline', React.lazy(() => import(`../../images/icons/IconFolderOutline`))],
  ['file', React.lazy(() => import(`../../images/icons/IconFile`))],
  ['new-application', React.lazy(() => import(`../../images/icons/IconNewApplication`))],
  ['looker', React.lazy(() => import(`../../images/icons/IconLooker`))],
  ['access', React.lazy(() => import(`../../images/icons/IconAccess`))],
  ['onboarding', React.lazy(() => import(`../../images/icons/IconOnboarding`))],
  ['policy', React.lazy(() => import(`../../images/icons/IconPolicy`))],
  ['reliability', React.lazy(() => import(`../../images/icons/IconReliability`))],
  ['ticket', React.lazy(() => import(`../../images/icons/IconTicket`))],
  ['menu', React.lazy(() => import(`../../images/icons/IconMenu`))],
  ['search', React.lazy(() => import(`../../images/icons/IconSearch`))],
  ['add-participant', React.lazy(() => import(`../../images/icons/IconAddParticipants`))],
  ['dont-notify', React.lazy(() => import(`../../images/icons/IconDontNotify`))],
  ['add-attachment', React.lazy(() => import(`../../images/icons/IconAddAttachment`))],
  ['send-link', React.lazy(() => import(`../../images/icons/IconSendLink`))],
  ['failed', React.lazy(() => import(`../../images/icons/IconFailed`))],
  ['passed', React.lazy(() => import(`../../images/icons/IconPassed`))],
  ['not-triggered', React.lazy(() => import(`../../images/icons/IconNotTriggered`))],
  ['in-progress', React.lazy(() => import(`../../images/icons/IconInProgress`))],
  ['workflow', React.lazy(() => import(`../../images/icons/IconWorkflow`))],
  ['knowledge-base', React.lazy(() => import(`../../images/icons/IconKnowledgeBase`))],
  ['logout', React.lazy(() => import(`../../images/icons/IconLogout`))],

  // images
  ['autopay', React.lazy(() => import(`../../images/icons/ImgAutopay`))],
  ['autopay-change', React.lazy(() => import(`../../images/icons/ImgAutopayChange`))],
  ['card-locked', React.lazy(() => import(`../../images/icons/ImgCardLocked`))],
  ['card-success', React.lazy(() => import(`../../images/icons/ImgCardSuccess`))],
  ['process-bank', React.lazy(() => import(`../../images/icons/ImgProcessBank`))],
  ['process-decision', React.lazy(() => import(`../../images/icons/ImgProcessDecision`))],
  ['process-snapshot', React.lazy(() => import(`../../images/icons/ImgProcessSnapshot`))],
  ['process-bank', React.lazy(() => import(`../../images/icons/ImgProcessBank`))],
]);

export const SORTED_ICONS = new Map([...SVG_INFO_MAP.entries()].sort());

export type VALID_ICON_ROTATION = '0' | '90' | '180' | '270' | '-90' | '-180' | '-270';

interface ISVGIconCommonProps extends React.HTMLAttributes<HTMLElement> {
  icon: VALID_ICONS;
  iconStyle?: VALID_SVG_COLOR;
  size?: string;
  color?: string;
  secondaryColor?: string;
  rotate?: VALID_ICON_ROTATION;
}

export interface ISVGIconDecorativeProps extends ISVGIconCommonProps {
  'aria-hidden'?: true;
}

export interface ISVGIconNonDecorativeProps extends ISVGIconCommonProps {
  'aria-hidden': false;
  iconTitle: string;
}

export type ISVGIconProps = ISVGIconDecorativeProps | ISVGIconNonDecorativeProps;

interface ISVGIconStyleWrapperProps {
  colorProp?: string;
  secondaryColor?: string;
  rotateProp?: VALID_ICON_ROTATION;
}

export type SVGIconStyleWrapperProps = Omit<ISVGIconProps, 'color'> & ISVGIconStyleWrapperProps;

export const SVGIconStyleWrapper = Styled.div<SVGIconStyleWrapperProps>`
  ${({ theme, size, iconStyle, colorProp, secondaryColor, rotateProp }) => css`

    ${iconStyle && css`
      color: ${theme.icon[iconStyle].colorIcon};

      svg {
        fill: currentColor;
      }
    `}

    ${size && css`
      &,
      svg {
        width: ${theme.themeTwo.global.edgeSize[size] || size};
        height: ${theme.themeTwo.global.edgeSize[size] || size};
      }
    `}

    ${colorProp && css`
      color: ${normalizeColor(theme.themeTwo, colorProp)};

      svg {
        fill: currentColor;
      }
    `}

    svg .secondaryColor {
      fill: ${secondaryColor ? normalizeColor(theme.themeTwo, secondaryColor) : 'none'};
    }

    ${rotateProp && css`
      svg {
        transform: rotate(${rotateProp}deg);
      }
    `}

    .statusOutline,
    .statusCircle {
      stroke: currentColor;
    }
  `}
`;

const SVGIcon: React.FC<ISVGIconProps> = ({
  'aria-hidden': ariaHidden = true,
  color,
  secondaryColor,
  icon,
  size,
  rotate,
  ...restProps
}) => {
  const Icon = SVG_INFO_MAP.get(icon);
  let iconTitle;

  if (!ariaHidden) {
     iconTitle = (restProps as ISVGIconNonDecorativeProps).iconTitle;
  }

  if (!Icon) {
    console.error(`Unrecognized Icon: ${icon}`);

    return null;
  }

  return (
    <SVGIconStyleWrapper
      rotateProp={rotate}
      colorProp={color}
      secondaryColor={secondaryColor}
      icon={icon}
      size={size}
      aria-hidden={ariaHidden}
      {...restProps}
    >
      <React.Suspense fallback={null}>
        <Icon
          focusable='false'
          role={!ariaHidden ? 'img' : undefined}
          iconTitle={iconTitle}
        />
      </React.Suspense>
    </SVGIconStyleWrapper>
  );
};

export default SVGIcon;
